import { defineMessages } from 'react-intl';

export default defineMessages({
  successIconLabel: {
    id: 'frontbucket.repository.pullrequest.forgeMergeChecksStatusIcon.successIconLabel',
    description: 'Label for icon indicating the merge check has succeeded',
    defaultMessage: 'Merge check passed',
  },
  impendingIconLabel: {
    id: 'frontbucket.repository.pullrequest.forgeMergeChecksStatusIcon.impendingIconLabel',
    description: 'Label for icon indicating the merge check is impending',
    defaultMessage: 'Merge check waiting to be run',
  },
  failedIconLabel: {
    id: 'frontbucket.repository.pullrequest.forgeMergeChecksStatusIcon.failedIconLabel',
    description: 'Label for icon indicating the merge check has failed',
    defaultMessage: 'Merge check failed',
  },
  inProgressIconLabel: {
    id: 'frontbucket.repository.pullrequest.forgeMergeChecksStatusIcon.inProgressIconLabel',
    description: 'Label for icon indicating the merge check is in progress',
    defaultMessage: 'Merge check in progress',
  },
});
